import axiosInstance from '@/app/api/axiosInstance';
import { Account, AccountListResponse } from '@/app/types/account';

const PAGE_SIZE = 500;

export const listAccounts = async (): Promise<Account[]> => {
    const allAccounts: Account[] = [];
    let skip = 0;

    while (true) {
        const response = await axiosInstance.get<AccountListResponse>('/accounts/', {
            params: {
                skip,
                limit: PAGE_SIZE,
                sort_by: 'name',
                sort_dir: 'asc',
            },
        });

        const items = response.data.items || [];
        allAccounts.push(...items);

        if (items.length < PAGE_SIZE) {
            break;
        }
        skip += PAGE_SIZE;
    }

    return allAccounts;
};
